/**
* Video Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import {Splide} from '@splidejs/splide';
import Plyr from 'plyr';
const players = Plyr.setup( '.js-player' );
( function( app ) {
  const COMPONENT = {

    className: 'video-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.video-slider-splide' ).length ) {
        $( '.video-slider-splide' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'slide',
            perPage: 2,
            perMove: 1,
            drag: false,
            arrows: true,
            pagination: false,
            padding: {
              right: '208px',
            },
            breakpoints: {
              768: {
                perPage: 1,
                padding: {
                  right: '0px',
                },
              },
            },
          } );

          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-slider', COMPONENT );
} )( app );
